import React, {useState, useEffect, useMemo, useRef} from 'react';
import {myService} from '@app/services/loaiphansucap2Service';
import {alertService} from '@app/services/alertService';
import {useLocation} from 'react-router-dom';
import * as mainService from '@app/services/mainService';
import '../../../css/styles/custom-table.css'
import {Input, Tabs} from "@components";
import {getControllerName, getDefaultSelectValue,renewTrangthai} from '@app/utils/helpers';
import {
    image_root,
    INIT_ROLE_MENU,
    PAGES_SIZE_DEFAULT, SERVER_YYYYMM_FORMAT
} from '@app/const/AppSetting';
import HeaderClick from '@app/utils/HeaderClick';
import Pagination from "@material-ui/lab/Pagination";
import {useDispatch, useSelector} from "react-redux";
import {DownloadFile,findObjInArr, formatCurencyVI, formatDateClient, getMenuName, isEmpty} from "@app/utils/CommonFunctions";
import Select, { components } from "react-select";
import {useTranslation} from "react-i18next";
import {Card, HRTag} from "@components";
import {loadMenu} from "@store/reducers/auth";
import {Button, Modal} from "react-bootstrap";
import {saveAs} from 'file-saver';
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import {trangthaiSlice} from "@store/reducers/trangthaiSlice";
import CapcoquanListComponent from '@app/pages/FUtil/CapcoquanListComponent';
import TrangthaiListComponent from '@app/pages/FUtil/TrangthaiListComponent';
import NewDataButton from '@app/utils/NewDataButton';
import CoquanListComponent from "@pages/FUtil/CoquanListComponent";
import Loaiphansucap1ListComponent from "@pages/FUtil/Loaiphansucap1ListComponent";
import {ClipLoader} from "react-spinners";
import dayjs from "dayjs";
const Loaiphansucap2List = ({ history }) => {
    const [t] = useTranslation();
    const pageSizes = PAGES_SIZE_DEFAULT;
    const location = useLocation();
    const currController = getControllerName(location.pathname);
    const dispatch = useDispatch();
    const menu = useSelector((state) => state.auth.menu);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

   
    const initialSearchItems =
    {
        loaipsc1_fk:null,
        coquan_fk:null,
        capcoquan_fk:null,
        ten:  "",    
        trangthai_fk : null,
        searchbyText: ''
    };

    const [removeToogle, setRemoveToogle] = useState(false);
    const [hasRole, setHasRole] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingTicket, setLoadingTicket] = useState(false);
    const [objs, setObjs] = useState([]);
    const [objAlls, setObjAlls] = useState([]);

    const [searchItems, setSearchItems] = useState({ ...initialSearchItems });
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [pageSize, setPageSize] = useState(pageSizes[2]);
    const [activeTab, setActiveTab] = useState(0);

    


    const onChangeFilter = async (e) => {
        let search = searchItems;
        search = { ...search, [e.target.name]: e.target.value };
        setSearchItems(search);
        if(e.target.name === 'maChungTu')
            await retrieveTutorials(search);
        if(e.target.name === 'tuNgay' || e.target.name === 'denNgay')
            storeSearchItems(search);
    };

    const onchangeInput = async (name, e) => {
        setLoadingTicket(true);
        

        let search = searchItems;
        search = { ...search, [name]: e ? e.value : '' };
        setSearchItems(search);
        setLoadingTicket(false);
    };


    const onSelectedChangeFilter = async (name, e) => {
        setLoadingTicket(true);
       
        let search = searchItems;
      
        search = { ...search, [name]: e ? e.value : '' };
        setSearchItems(search);
        storeSearchItems(search);
        await retrieveTutorials(search);
        setLoadingTicket(false);
    };

    const storeSearchItems = (searchItems) => {
        const newMenu = menu.map((elem) => {
            return {
                ...elem,
                children: elem.children.map((item) =>
                    item.path.includes(currController) ? { ...item, searchItems: searchItems } : item,
                ),
            };
        });
        //console.log(JSON.stringify(newMenu));
        dispatch(loadMenu(newMenu));
    };


    const retrieveTutorials = async (search) => {

        if(!search)
            search = searchItems;
        const { data, pageinfo } = await  myService
            .getAll(page, pageSize, search);

        setObjs(data);
        setObjAlls(data);
        setCount(pageinfo.totalpage);

    };
     
    const createRs = async () => {
        setLoading(true);
         setLoading(false);
    }
    const loadTable = async () => {
        setLoadingTicket(true);
        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);

            setRoleMenu(role);
            setHasRole(true);
        }
        let search = {};
        menu.forEach((elem) => {
            const m = elem.children.find((item) => item.path.includes(currController));
            if (m != undefined) search = m;
        });
        setSearchItems(search.searchItems || initialSearchItems);
        await retrieveTutorials(search.searchItems || initialSearchItems);
        let divtb1 = document.getElementById("divtb1");
        setActiveTab(divtb1 ? 0 : 1)
        setLoadingTicket(false);
    }

    useEffect(async () => {
         await mainService.checkRole({
                    pathname: location.pathname,
                    isAddMode: false,
                    currController,
                    history
                });
         await createRs();
       // setLoading(false);
    }, []);

    useEffect(async () => {
        await createRs();
        await loadTable();
    }, [removeToogle, page, pageSize]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }


    const findByTitle = async () => {
        setLoading(true);
        setPage(1);
        await retrieveTutorials();
        setLoading(false);
    };

    const removeSearch = async () => {
        setPage(1);
        setSearchItems({...initialSearchItems});
        setRemoveToogle((prevSelected) => {
            return !prevSelected;
        });
        //await retrieveTutorials(initialSearchItems);
    };
    const handlePageChange = (event, value) => {
        setPage(value);
    };


    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    const editdonhang = (rowIndex) => {
        const { id } = objs[rowIndex];
        history.push(`/${currController}/edit/${id}`);
    };
    
    const opendonhang = (rowIndex) => {
        const { id } = objs[rowIndex];
        history.push(`/${currController}/view/${id}`);
    };

    const deletedonhang = async (rowIndex) => {
        const { id } = objs[rowIndex];
        const result = await myService.Delete(id);
        if (result.status === "1") {
            alertService.success(t('fields.label.xoathanhcong'));
            await retrieveTutorials();
        } else {
            alertService.error(result.msg);
        }
    };
    const printdonhang = (rowIndex) => {
        const { id } = objs[rowIndex];
        history.push(`/${currController}/print/${id}`);
    };

    const excel = async () => {
        setLoading(true);

        await myService.excel(page, pageSize, searchItems).then((d) => {
          //  console.log(d);
            const blob = new Blob([d.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob,roleMenu.tenmenu);
        }).catch(alertService.error);
        setLoading(false);
    };

    const excelPath = async (action) => {
        setLoading(true);

        const result = await myService.excelPath({...searchItems,uploadType :action});
        setLoading (false);
        if (result.status==="1") {

            await  DownloadFile( image_root + result.data, result.data2);

        } else {
            alertService.error(result.msg,);
        }

    };

    const viewTable = (
        loadingTicket ? (
            <div className="loading-state">
                <ClipLoader color="#3498db" size={50} />
            </div>
        ) : (
            <div className="card shadow-sm border-0">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead className="custom-table-header">
                            <tr>
                                <th className="text-center" style={{ width: '8%' }}>STT</th>
                                <th className="text-start" style={{ width: '22%' }}>Tên loại phận sự cấp 2</th>
                                <th className="text-left" style={{ width: '32%' }}>Loại phận sự cấp 1</th>
                                <th className="text-center" style={{ width: '8%' }}>Trạng thái</th>
                                <th className="text-center" style={{ width: '15%' }}>Thông tin cập nhật</th>
                                <th className="text-center" style={{ width: '15%' }}>Tác vụ</th>
                            </tr>
                            </thead>
                            <tbody>
                            {objs && objs.map((item, i) => {
                                let editable = [];

                                if (roleMenu.quyenhienthi === 1) {
                                    editable.push(
                                        <button
                                            className="btn btn-info btn-sm table-action-btn"
                                            key={`view-${i}`}
                                            title={t('action.label.view')}
                                            onClick={() => opendonhang(i)}
                                        >
                                            <i className="fas fa-eye"></i>
                                        </button>
                                    );
                                }

                                if (roleMenu.quyenchinhsua === 1) {
                                    editable.push(
                                        <button
                                            className="btn btn-warning btn-sm table-action-btn"
                                            key={`edit-${i}`}
                                            title={t('action.label.edit')}
                                            onClick={() => editdonhang(i)}
                                        >
                                            <i className="fas fa-pencil-alt"></i>
                                        </button>
                                    );
                                }

                                if (roleMenu.quyenxoa === 1) {
                                    editable.push(
                                        <button
                                            className="btn btn-danger btn-sm table-action-btn"
                                            key={`delete-${i}`}
                                            title={t('action.label.delete')}
                                            onClick={() => {
                                                if (window.confirm(t('fields.label.bancomuonxoa'))) {
                                                    deletedonhang(i);
                                                }
                                            }}
                                        >
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    );
                                }

                                return (
                                    item && (
                                        <tr key={`item-${i}`} className="custom-table-row">
                                            <td className="text-center custom-table-cell">
                                                <span className="badge bg-secondary rounded-pill table-stt-badge">
                                                    {i + 1}
                                                </span>
                                            </td>

                                            <td className="text-start custom-table-cell">
                                                <div className="fw-medium text-dark" style={{ fontSize: '0.9rem' }}>
                                                    {item.ten}
                                                </div>
                                            </td>

                                            <td className="text-left custom-table-cell">
                                                <span className="fw-medium text-dark" style={{ fontSize: '0.9rem' }}>
                                                    {item.lpcsc1}
                                                </span>
                                            </td>

                                            <td className="text-center custom-table-cell">
                                                <i className={
                                                    item.trangthai_fk === 1
                                                        ? "fas fa-check-circle text-success table-status-icon"
                                                        : item.trangthai_fk === 0
                                                            ? "fas fa-lock text-secondary table-status-icon"
                                                            : "fas fa-exclamation-circle text-danger table-status-icon"
                                                } title={item.trang_thai}></i>
                                            </td>

                                            <td className="text-center custom-table-cell">
                                                <div className="update-info-card">
                                                    {item.ngay_tao && (
                                                        <div className="update-section create-section">
                                                            <span className="update-inline">
                                                                <i className="fas fa-plus-circle me-1"></i>
                                                                <strong>Tạo:</strong> {dayjs(item.ngay_tao).format("DD/MM/YYYY HH:mm")} - {item.nguoi_tao || 'N/A'}
                                                            </span>
                                                        </div>
                                                    )}
                                                    <div className="update-section modify-section">
                                                        <span className="update-inline">
                                                            <i className="fas fa-edit me-1"></i>
                                                            <strong>Sửa:</strong> {dayjs(item.ngay_sua).format("DD/MM/YYYY HH:mm")} - {item.nguoi_sua}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="text-center custom-table-cell">
                                                <div className="d-flex justify-content-center gap-1">
                                                    {editable}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                );
                            })}
                            </tbody>
                        </table>
                    </div>

                    {(!objs || objs.length === 0) && (
                        <div className="empty-state">
                            <div className="text-muted mb-3">
                                <i className="fas fa-inbox fa-2x"></i>
                            </div>
                            <p className="text-muted">Không có dữ liệu để hiển thị</p>
                        </div>
                    )}
                </div>
            </div>
        )
    );

    return !loading && (
        <div className="card card-primary">
            <HeaderClick
                isIndex
                headerName={roleMenu.tenmenu}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                <Card title={t('fields.label.boloctimkiem')} isDefaultActive>
                    <div className="card-body">
                        <div className="form-row small">

                            <div className="form-group col-md-2">
                                <TrangthaiListComponent trangthai_fk = {searchItems.trangthai_fk}
                                    onChange ={(e) => onSelectedChangeFilter('trangthai_fk', e)}
                                    filterIds = { [0,1] }
                                    trangthaiName = "name"
                                />
                            </div>
                            <div className="form-group-sm col-sm-2">
                                <CoquanListComponent
                                    coquan_fk= {searchItems.coquan_fk}
                                    onChange ={(e) => onSelectedChangeFilter('coquan_fk', e)} />
                            </div>
                            <div className="form-group-sm col-sm-2">
                                <CapcoquanListComponent
                                    capcoquan_fk= {searchItems.capcoquan_fk}
                                    onChange ={(e) => onSelectedChangeFilter('capcoquan_fk', e)} />
                            </div>
                            <div className="form-group-sm col-sm-2">
                                <Loaiphansucap1ListComponent
                                    loaipsc1_fk= {searchItems.loaipsc1_fk}
                                    onChange ={(e) => onSelectedChangeFilter('loaipsc1_fk', e)} />
                            </div>

                            <div className="form-group-sm col-sm-2">
                                <label>Tên</label>
                                <input
                                    type='text'
                                    className="form-control"
                                    name="ten"
                                    id ="ten"
                                    value={searchItems.ten}
                                    onChange={(e) => onSelectedChangeFilter('ten', e.target)}
                                    //onBlur={(e) => onSelectedChangeFilter('ten', e.target)}
                                />
                            </div>


                        </div>
                    </div>
                    <div className="card-footer">
                        {/*<button className="btn btn-info mr-1" type="button" onClick={findByTitle}>
                            <i className="fa fa-search"></i>
                        </button>*/}
                        <button className="btn btn-dark mr-1" type="button" onClick={removeSearch}>
                            <i className="fa fa-undo"></i>
                        </button>
                        <Button type="button" className="btn btn-primary mr-1" onClick={() =>{ excel();}}>
                            <i className="fa fa-file-excel">   {`Excel` }</i>
                        </Button>
                        <NewDataButton
                            route={location.pathname}
                            roleMenu={roleMenu}
                            history={history}
                        />
                    </div>
                </Card>

                <HRTag title={t('fields.label.ketqua') + ' - '+ t('fields.label.list')}/>


                {viewTable}

                <div className="mt-3">
                    {t('footer.itemperpage')}
                    <select onChange={handlePageSizeChange} value={pageSize}>
                        {pageSizes.map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>

                    <Pagination
                        className="my-3"
                        count={count}
                        page={page}
                        siblingCount={1}
                        boundaryCount={1}
                        variant="outlined"
                        shape="rounded"
                        onChange={handlePageChange}
                    />
                </div>


            </div>
        </div>
    );
};

export default Loaiphansucap2List;
